<section class="section">
  <h3 class="heading">{{data.title}}</h3>
  <ul class="list">
    <li class="list__item">
      <span [innerHTML]="data.description | safePureHtml"></span>
    </li>
  </ul>
  <p *ngIf="data.note"
     class="note"
     [innerHTML]="data.note | safePureHtml"></p>
</section>
